var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { getAutomation, getDebug, useCitrusDebug } from '@citrus/runtime';
import { Styled } from './Sortable.styled';
var VERSION = '2.5.0';
var Section = function (_a) {
    var automationId = _a.automationId, id = _a.id, children = _a.children, _b = _a.disabled, disabled = _b === void 0 ? false : _b, onDrop = _a.onDrop, rawId = _a.rawId, renderSection = _a.renderSection, renderSubheader = _a.renderSubheader, sortableOptions = _a.sortableOptions, title = _a.title, TYPE = _a.__TYPE;
    var debug = useCitrusDebug();
    if (disabled) {
        return (React.createElement(Styled.SectionDiv, __assign({ className: 'pcty-sortable-section-disabled', id: id }, getAutomation(automationId, 'section'), getDebug(debug, TYPE, VERSION)),
            React.createElement(Styled.SectionTitle, null,
                React.createElement(Styled.Column, null,
                    React.createElement(Styled.Handle, null)),
                handleRenderSection(rawId, renderSection, title)), renderSubheader === null || renderSubheader === void 0 ? void 0 :
            renderSubheader(),
            children));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Styled.Section, __assign({ className: 'pcty-sortable-draggable', "data-section-id": rawId, id: id, onChange: onDrop, options: sortableOptions }, getAutomation(automationId, 'section'), getDebug(debug, TYPE, VERSION)),
            React.createElement(Styled.SectionTitle, null,
                React.createElement(Styled.Column, null,
                    React.createElement(Styled.Handle, null)),
                handleRenderSection(rawId, renderSection, title)),
            React.createElement(Styled.Section, { className: 'pcty-sortable-section-empty-target-middle', id: id + '-empty-target-middle', onChange: onDrop, options: sortableOptions }), renderSubheader === null || renderSubheader === void 0 ? void 0 :
            renderSubheader(),
            children)));
};
var handleRenderSection = function (id, renderSection, title) {
    if (!renderSection) {
        return React.createElement(Styled.Column, null, title);
    }
    return renderSection(title, id);
};
Section.defaultProps = {
    __TYPE: 'Section',
};
export default Section;
